/**
 * @generated SignedSource<<702dcff845a2fa326efa462282b4bee2>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum ConfluenceEdition {
  FREE = "FREE",
  PREMIUM = "PREMIUM",
  STANDARD = "STANDARD",
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_ancestors_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase =
  {
    __typename?: "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
    webui: string | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_ancestors_Content =
  {
    __typename?: "Content";
    id: string | null;
    hasViewRestrictions: boolean;
    links: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_ancestors_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_operations_OperationCheckResult =
  {
    __typename?: "OperationCheckResult";
    operation: string | null;
    targetType: string | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase =
  {
    __typename?: "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
    webui: string | null;
    base: string | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content =
  {
    __typename?: "Content";
    id: string | null;
    links: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions =
  {
    __typename?: "UserWithRestrictions";
    type: string | null;
    displayName: string | null;
    accountId: string | null;
    hasSpaceViewPermission: boolean | null;
    hasSpaceEditPermission: boolean | null;
    permissionType: SitePermissionType | null;
    profilePicture: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_profilePicture_Icon | null;
    restrictingContent: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    hasNextPage: boolean | null;
    endCursor: string | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions =
  {
    __typename?: "PaginatedUserWithRestrictions";
    count: number | null;
    nodes: Array<RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions | null> | null;
    pageInfo: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_pageInfo_PageInfo | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_nodes_Group =
  {
    __typename?: "Group";
    id: string | null;
    name: string | null;
    permissionType: SitePermissionType | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    hasNextPage: boolean | null;
    endCursor: string | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList =
  {
    __typename?: "PaginatedGroupList";
    count: number | null;
    nodes: Array<RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_nodes_Group | null> | null;
    pageInfo: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_pageInfo_PageInfo | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType =
  {
    __typename?: "SubjectsByType";
    userWithRestrictions: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions | null;
    group: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction =
  {
    __typename?: "ContentRestriction";
    restrictions: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction_restrictions_SubjectsByType | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase =
  {
    __typename?: "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase";
    webui: string | null;
    base: string | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content =
  {
    __typename?: "Content";
    id: string | null;
    links: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content_links_LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions =
  {
    __typename?: "UserWithRestrictions";
    type: string | null;
    displayName: string | null;
    accountId: string | null;
    hasSpaceViewPermission: boolean | null;
    hasSpaceEditPermission: boolean | null;
    permissionType: SitePermissionType | null;
    profilePicture: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_profilePicture_Icon | null;
    restrictingContent: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions_restrictingContent_Content | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    hasNextPage: boolean | null;
    endCursor: string | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions =
  {
    __typename?: "PaginatedUserWithRestrictions";
    count: number | null;
    nodes: Array<RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_nodes_UserWithRestrictions | null> | null;
    pageInfo: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions_pageInfo_PageInfo | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_nodes_Group =
  {
    __typename?: "Group";
    id: string | null;
    name: string | null;
    permissionType: SitePermissionType | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_pageInfo_PageInfo =
  {
    __typename?: "PageInfo";
    hasNextPage: boolean | null;
    endCursor: string | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList =
  {
    __typename?: "PaginatedGroupList";
    count: number | null;
    nodes: Array<RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_nodes_Group | null> | null;
    pageInfo: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList_pageInfo_PageInfo | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType =
  {
    __typename?: "SubjectsByType";
    userWithRestrictions: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_userWithRestrictions_PaginatedUserWithRestrictions | null;
    group: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType_group_PaginatedGroupList | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction =
  {
    __typename?: "ContentRestriction";
    restrictions: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction_restrictions_SubjectsByType | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions =
  {
    __typename?: "ContentRestrictions";
    read: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_read_ContentRestriction | null;
    update: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions_update_ContentRestriction | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_space_Space =
  {
    __typename?: "Space";
    id: string | null;
    containsExternalCollaborators: boolean;
    externalCollaboratorCount: number;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content =
  {
    __typename?: "Content";
    id: string | null;
    hasInheritedRestrictions: boolean;
    hasRestrictions: boolean;
    hasViewRestrictions: boolean;
    title: string | null;
    type: string | null;
    status: string | null;
    subType: string | null;
    ancestors: Array<RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_ancestors_Content | null> | null;
    operations: Array<RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_operations_OperationCheckResult | null> | null;
    restrictions: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_restrictions_ContentRestrictions | null;
    space: RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content_space_Space | null;
  };
export type RestrictionsDialogQuery_content_PaginatedContentListWithChild = {
  __typename?: "PaginatedContentListWithChild";
  nodes: Array<RestrictionsDialogQuery_content_PaginatedContentListWithChild_nodes_Content | null> | null;
};
export type RestrictionsDialogQuery_user_AtlassianUser_photos_AtlassianUserPhoto =
  {
    __typename?: "AtlassianUserPhoto";
    value: string | null;
    isPrimary: boolean | null;
  };
export type RestrictionsDialogQuery_user_AtlassianUser = {
  __typename?: "AtlassianUser";
  id: string | null;
  displayName: string | null;
  photos: Array<RestrictionsDialogQuery_user_AtlassianUser_photos_AtlassianUserPhoto | null> | null;
};
export type RestrictionsDialogQuery_tenant_ConfluenceTenantContext_editions_Editions =
  {
    __typename?: "Editions";
    confluence: ConfluenceEdition;
  };
export type RestrictionsDialogQuery_tenant_ConfluenceTenantContext = {
  __typename?: "ConfluenceTenantContext";
  editions: RestrictionsDialogQuery_tenant_ConfluenceTenantContext_editions_Editions;
};
export type RestrictionsDialogQuery_Query = {
  __typename?: "Query";
  content: RestrictionsDialogQuery_content_PaginatedContentListWithChild | null;
  user: RestrictionsDialogQuery_user_AtlassianUser | null;
  tenant: RestrictionsDialogQuery_tenant_ConfluenceTenantContext | null;
};
export type RestrictionsDialogQueryVariables = Exact<{
  contentId: Scalars["ID"]["input"];
  status?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
  draftShareId?: InputMaybe<Scalars["String"]["input"]>;
  readUserStart?: InputMaybe<Scalars["Int"]["input"]>;
  readGroupStart?: InputMaybe<Scalars["Int"]["input"]>;
  editUserStart?: InputMaybe<Scalars["Int"]["input"]>;
  editGroupStart?: InputMaybe<Scalars["Int"]["input"]>;
}>;
export type RestrictionsDialogQuery = RestrictionsDialogQuery_Query;
